import { useState, useEffect } from 'react'
import api from './api'
import '../css/Nav.css'

import Logo from '../images/logo.png'

import { UserOutlined, NotificationOutlined, ExportOutlined, PieChartOutlined, ControlOutlined } from '@ant-design/icons'
import { Button, Badge, message, Avatar, Dropdown, Input, Tag, Typography, Modal, Image, ConfigProvider } from 'antd'
import { Link, useLocation, useNavigate } from 'react-router-dom'

const { Search } = Input
const { Text } = Typography

//  检查登陆状态
function CheckLoginStatus(props) {
    const location = useLocation()
    const navigate = useNavigate()

    let items = [
        {
            key: 'user_nid',
            label: 'NID: ' + props.state.user.nid,
            icon: <><i class="fa-solid fa-id-card" style={{ marginRight: 8 }}></i></>,
            style: {
                width: 160
            }
        },
        {
            key: 'user',
            label: '个人资料',
            icon: <UserOutlined />,
            style: {
                width: 160
            }
        },
        {
            key: 'console',
            label: '控制台',
            icon: <PieChartOutlined />,
            style: {
                width: 160
            }
        }
    ]

    if (props.verifyAy('admin')) {
        items.push({
            key: 'admin',
            label: '站务管理',
            icon: <ControlOutlined />,
            style: {
                width: 160
            }
        })
    }

    items.push({
        type: 'divider'
    })
    items.push({
        key: 'quit',
        label: '退出登陆',
        icon: <ExportOutlined />,
        danger: true
    })

    //  处理下文列表菜单
    function onClick({ key }) {
        if (key === 'quit') {
            // message.error('已退出登陆')

            api.post('/api/v2/user/update', {
                type: 'exit',
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        message.success('已退出登陆')
                        props.clearCookie('n2yunToken')
                        props.handleChange({
                            token: null,
                            user: {},
                            login: false
                        })
                        localStorage.removeItem('n2yun_token')
                        localStorage.removeItem('n2yun_user')
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器')
                })
        }
        if (key === 'console') {
            navigate('/app/home')
        }
        if (key === 'cloud') {
            navigate('/cloud/cwhitelist')
        }
        if (key === 'user') {
            navigate('/app/set')
        }
        if (key === 'admin') {
            navigate('/admin/home')
        }
    }

    if (props.state.token) {
        return (
            <>
                <Badge dot={props.show} style={{ marginRight: 10 }} >
                    <NotificationOutlined onClick={props.ShowClick} style={{ fontSize: 20, marginRight: 10 }} />
                </Badge>
                <Dropdown
                    menu={{
                        items,
                        onClick
                    }}
                    placement="bottomRight"
                >
                    <Avatar size={34} src={<img src={props.function.getAvatar()} alt='avatar' />} />
                </Dropdown>
            </>
        )
    } else {
        return (
            <>
                <Link to={{ "pathname": "/login", search: "?redirect=" + location.pathname }} >
                    <Button icon={<UserOutlined />}>登录</Button>
                </Link>
            </>
        )
    }
}

//  导航栏
const Nav = (props) => {
    const [show, setShow] = useState(false)
    const [qr_url, setQr_url] = useState(false)
    const navigate = useNavigate()

    let nav = 'nav'
    if (props.state.isMobile) {
        nav = 'nav-m'
    }

    useEffect(() => {
        if (props.state.user) {
            if (props.state.user.dot) {
                setShow(true)
            } else {
                setShow(false)
            }
        }
    }, [props.state.user])

    //  操作通知
    const ShowClick = () => {
        navigate('/notify')
    }

    const onSearch = (value) => {
        navigate('/search/' + value)
    }

    function SwitchWeChat() {
        api.post('/api/v2/open_access/sso', {
            name: 'SwitchWeChat',
        })
            .then((res) => {
                if (res.data.code === 200) {
                    setQr_url(res.data.data.data.qr_url)
                    message.success('二维码获取成功!')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }

    return (
        <div>
            {/* <div className='a666 animate__animated animate__lightSpeedInLeft'><Text><Tag color="#108ee9" variant='solid'>业务上新</Tag> 原图床业务更新为云存储业务! <Typography.Link href="/app/product" >了解更多</Typography.Link></Text></div> */}
            <div className='a666 animate__animated animate__lightSpeedInLeft'><Text>不一样的技术价值, 分享使世界更精彩</Text></div>
            {/* <div className='a666'><Tag color="#108ee9">官网通知</Tag> 关于我站更新官网域名 <Typography.Link href="/t/371" >了解更多</Typography.Link></div> */}
            {/* <div className='a666'><Tag color="#e00d0b">下线通知</Tag> 我站的图床业务下线 <Typography.Link href="/t/364" >了解更多</Typography.Link></div> */}
            <div className='nav' >
                <div id={nav}>
                    <div className='logo animate__animated animate__lightSpeedInLeft'>
                        <Link to="/">
                            <img src={Logo} alt='logo'></img>
                        </Link>
                    </div>
                    <div className='link' style={{ display: `${props.state.isMobile ? 'none' : ''}` }}>
                        <Button href='/nzadmin' style={{ marginRight: 10, textDecoration: 'none' }}>NZadmin 管理面板 (维护)</Button>
                        {/* <Button style={{ marginRight: 10, textDecoration: 'none' }} onClick={() => { SwitchWeChat() }} type="primary" defaultBg='#07C160' >快捷切换微信入口</Button> */}


                        {/* <ConfigProvider
                            theme={{
                                token: {
                                    // Seed Token, affects wide range
                                    colorPrimary: '#00b96b',
                                    borderRadius: 2,
                                    // Derived token, affects narrow range
                                    colorBgContainer: '#f6ffed',
                                },
                            }}
                        >
                            <Button style={{ marginRight: 10, textDecoration: 'none' }} onClick={() => { SwitchWeChat() }} type="primary" defaultBg='#07C160' >快捷切换微信入口</Button>
                        </ConfigProvider> */}

                        {/* <Button href='https://docs.n2yun.com.cn/' target="_blank">N2YUN知识库</Button> */}
                    </div>
                    <div className='user_profile'>
                        <Search
                            placeholder="搜索..."
                            onSearch={onSearch}
                            enterButton
                            style={{
                                width: props.state.isMobile ? 120 : 200,
                                marginRight: 10
                            }}
                        />
                        <CheckLoginStatus {...props} show={show} ShowClick={ShowClick} />
                    </div>
                </div>
            </div>






            <Modal
                title="使用微信扫一扫"
                centered
                open={qr_url}
                onOk={() => setQr_url(false)}
                onCancel={() => setQr_url(false)}
                width={'50%'}
            >
                <Image
                    width={'50%'}
                    alt="basic"
                    src={qr_url}
                />
            </Modal>
        </div>
    )
}

export default Nav